import React from "react"
import Helmet from "react-helmet"
import Uninstall from "@tightrope/footerlinks/uninstall"
import HomepageLayout from "src/layouts/homepage"
import JSONData from "branding/site-metadata.json"

export default function UninstallPage() {
  return(

    <HomepageLayout>
        <Helmet data={JSONData}>
        <style type="text/css">{`
       
       .footerlinks-module--footerlinksContainer {
        position:relative;
        padding:0 0 100px 0;
      }

              footer {
        font-family: 'Roboto', sans-serif;
        position: relative;
        width: 100%;
        padding: 20px 0;
        background:#444;
      }
      footer ul {
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 90%;
        max-width: 1200px;
        margin: 0 auto;
        list-style: none;
        color: #d4d4d4;
        font-size: 12px;
        }
        footer ul li {
          padding:0 6px 0 0;
        }

        footer ul li a {
          color:#d4d4d4;
        }

        footer ul li a:hover {
          color:#d4d4d4;
        }

        footer ul li:last-child {
          padding:0;
        }

        footer ul li:after {
          content: '|';
          padding:0 0 0 6px;
        }

        footer ul li:last-child:after {
          content:none;
          padding:0;
        }

    `}
    </style>
          <title>Uninstall - frompdftodoc.com</title></Helmet>
    <Uninstall>    <Helmet>Test</Helmet></Uninstall>
    </HomepageLayout>
  )
}
